var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX314EmailNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.341,
    height: 27.61,
    viewBox: "0 0 35.341 27.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_Email_notification",
    transform: "translate(0 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34950",
    "data-name": "Group 34950",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34454",
    "data-name": "Path 34454",
    d: "M29.267,24.731a.552.552,0,0,0-.552.552V36.327a1.659,1.659,0,0,1-1.657,1.657H2.761A1.659,1.659,0,0,1,1.1,36.327V19.761A1.659,1.659,0,0,1,2.761,18.1H21.536a.552.552,0,1,0,0-1.1H2.761A2.764,2.764,0,0,0,0,19.761V36.327a2.764,2.764,0,0,0,2.761,2.761h24.3a2.764,2.764,0,0,0,2.761-2.761V25.283A.552.552,0,0,0,29.267,24.731Z",
    transform: "translate(0 -11.478)",
    fill: "#ff6c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34455",
    "data-name": "Path 34455",
    d: "M25.578,24.5a.552.552,0,0,0-.78-.041l-6.542,5.888a2.384,2.384,0,0,1-3.112,0l-10.223-9.2a.552.552,0,1,0-.739.821L13.444,30.3l-9.237,7.39a.552.552,0,0,0,.69.863l9.379-7.5.13.117a3.43,3.43,0,0,0,4.589,0l.13-.117,9.379,7.5a.552.552,0,1,0,.691-.861L19.957,30.3l5.58-5.022a.552.552,0,0,0,.041-.78Z",
    transform: "translate(-1.791 -13.27)",
    fill: "#ff6c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34456",
    "data-name": "Path 34456",
    d: "M48.074,7a6.074,6.074,0,1,0,6.074,6.074A6.081,6.081,0,0,0,48.074,7Zm0,11.044a4.97,4.97,0,1,1,4.97-4.97A4.976,4.976,0,0,1,48.074,18.044Z",
    transform: "translate(-18.808 -7)",
    fill: "#ff6c84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX314EmailNotification);
export default __webpack_public_path__ + "static/media/_x31_4_Email_notification.9177fbb8e6e23dde88e204143ad0b2da.svg";
export { ForwardRef as ReactComponent };